import styled, { css, createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    outline: none;
    box-sizing: border-box;
  }

  body {
    background: white;
    margin: 0;
  }

  html {
    font-size: 16px;

    @media (max-width: 1550px) {
      font-size: 14px;
    }

    @media (max-width: 1300px) {
      font-size: 12px;
    }
  }
`;

const BaseStyles = styled.div(
  ({ theme }) => css`
    font-family: ${theme.fonts.body};
    color: ${theme.colors.main.font};

    button {
      font-family: ${theme.fonts.body};
      transition: color 0.35s ease, background-color 0.35s ease,
        box-shadow 0.35s ease;
    }

    input,
    textarea,
    select {
      font-size: ${theme.fonts.sizes.text};
      font-family: ${theme.fonts.body};
      color: ${theme.colors.main.font};
      transition: border 0.35s ease;
    }

    h1,
    .h1 {
      font-family: ${theme.fonts.heading};
      font-size: ${theme.fonts.sizes.h1};
      font-weight: 600;
      margin-top: 0;
      line-height: 2.625rem;
    }

    h2,
    .h2 {
      font-family: ${theme.fonts.heading};
      font-size: ${theme.fonts.sizes.h2};
      font-weight: 600;
      margin-top: 0;
    }

    h3,
    .h3 {
      font-family: ${theme.fonts.heading};
      font-size: ${theme.fonts.sizes.h3};
      font-weight: 600;
      margin-top: 0;
    }

    h4,
    .h4 {
      font-family: ${theme.fonts.body};
      font-size: ${theme.fonts.sizes.h4};
      font-weight: 500;
      margin-top: 0;
    }

    h5,
    .h5 {
      font-family: ${theme.fonts.body};
      font-size: ${theme.fonts.sizes.h5};
      font-weight: 500;
      margin-top: 0;
    }

    h6,
    .h6 {
      font-family: ${theme.fonts.body};
      font-size: ${theme.fonts.sizes.h6};
      font-weight: 500;
      margin-top: 0;
    }

    a {
      text-decoration: none;
      transition: color 0.35s ease, background-color 0.35s ease,
        box-shadow 0.35s ease;
    }

    .material-symbols-rounded {
      vertical-align: middle;
      font-variation-settings: 'FILL' 1, 'wght' 700, 'GRAD' 0, 'opsz' 20;
    }

    .material-symbols-rounded.no-fill {
      font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 20;
    }
  `
);

export { GlobalStyles, BaseStyles };
